import { DeviceBrowser, DeviceClient } from "./Data";
var LocalDevice = /** @class */ (function () {
    function LocalDevice() {
    }
    LocalDevice.getMachineId = function () {
        if (this.machineIdCache)
            return this.machineIdCache;
        var machineId = localStorage.getItem("MachineId");
        if (!machineId) {
            machineId = crypto.randomUUID();
            localStorage.setItem("MachineId", machineId);
        }
        return machineId;
    };
    LocalDevice.GetBrowser = function () {
        if (this.browserCache)
            return this.browserCache;
        if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) != -1)
            return "Opera";
        else if (navigator.userAgent.indexOf("Edg") != -1)
            return "Edge";
        else if (navigator.userAgent.indexOf("Chrome") != -1)
            return "Chrome";
        else if (navigator.userAgent.indexOf("Safari") != -1)
            return "Safari";
        else if (navigator.userAgent.indexOf("Firefox") != -1)
            return "Firefox";
        else if (navigator.userAgent.indexOf("MSIE") != -1 || !!document.DOCUMENT_NODE == true)
            return "IE"; //IF IE > 10
        else
            return "Browser";
    };
    LocalDevice.getBrowser = function () {
        if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) != -1)
            return DeviceBrowser.Opera;
        else if (navigator.userAgent.indexOf("Edg") != -1)
            return DeviceBrowser.Edge;
        else if (navigator.userAgent.indexOf("Chrome") != -1)
            return DeviceBrowser.Chrome;
        else if (navigator.userAgent.indexOf("Safari") != -1)
            return DeviceBrowser.Safari;
        else if (navigator.userAgent.indexOf("Firefox") != -1)
            return DeviceBrowser.Firefox;
        else
            return DeviceBrowser.Other;
    };
    LocalDevice.getClient = function () {
        if (window.matchMedia("(display-mode: standalone)").matches
            || window.matchMedia("(display-mode: fullscreen)").matches)
            return DeviceClient.PWA;
        else
            return DeviceClient.Web;
    };
    LocalDevice.machineIdCache = null;
    LocalDevice.browserCache = null;
    LocalDevice.instanceIdCache = null;
    return LocalDevice;
}());
export { LocalDevice };
